var _circle, _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThpSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Temp Pres Humd_Small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.44,
    cy: 165.56,
    r: 34.44,
    fill: "#898989"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.68,
    y: 0.35,
    width: 25.52,
    height: 195.23,
    rx: 12.76,
    fill: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.5,170.84a29.16,29.16,0,1,1-58.31,0c0-16.1,29.15-84,29.15-84S171.5,154.74,171.5,170.84Z",
    fill: "#898989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34,23.92a6,6,0,0,0-11.62-2.15c-.85,1.43-4.23,6-13,6-5.66,0-12.48-4.81-19.09-9.46-7.31-5.15-14.22-10-21.52-10-14.19,0-23.37,11.46-23.75,12a6,6,0,1,0,9.36,7.4c.06-.07,6.07-7.42,14.39-7.42,3.52,0,9.43,4.17,14.65,7.85,7.75,5.45,16.52,11.63,26,11.63,15.18,0,21.71-9.15,23.52-12.32A6,6,0,0,0,188.34,23.92Z",
    fill: "#898989"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M188,56.71a6,6,0,0,0-11.65-2.06c-1.25,1.78-4.78,5.46-12.65,5.46-5.66,0-12.48-4.81-19.09-9.46-7.31-5.15-14.22-10-21.52-10-14.19,0-23.37,11.46-23.75,11.95a6,6,0,1,0,9.36,7.4c.06-.07,6.07-7.42,14.39-7.42,3.52,0,9.43,4.17,14.65,7.84,7.75,5.46,16.52,11.64,26,11.64,18,0,23.82-12.83,24.06-13.37l-.08,0A6.09,6.09,0,0,0,188,56.71Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThpSmall);
export default __webpack_public_path__ + "static/media/THP_Small.facc6b00ce74eba59a34f59f13006fc6.svg";
export { ForwardRef as ReactComponent };